import { overlayModule, useOverlayModule } from '../app/lazyOverlay';

const wizard = overlayModule(() => import('./FacebookOnboarding'));

/** Keep the wizard and its guide out of the dashboard's initial bundle. */
export function OnboardingLauncher({
  open,
  onClose,
  onConnected,
  additional,
}: {
  open: boolean;
  onClose: () => void;
  onConnected?: (accountId: string) => Promise<void>;
  additional?: boolean;
}) {
  const module = useOverlayModule(wizard, open);
  if (!open) return null;
  if (!module)
    return (
      <div role="status" aria-live="polite">
        Opening Facebook setup…
      </div>
    );
  const FacebookOnboarding = module.default;
  return <FacebookOnboarding onClose={onClose} onConnected={onConnected} additional={additional} />;
}
